/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import type { RichText } from './rich-text'
import { type CTAVideo, CTAVideoSchema } from './video'

/* TypeScript */
export type ContentProps = {
  technicalName?: string
  title?: string
  contentText: RichText
  subtitle?: string
  ctaLink?: CTALink
  ctaVideo?: CTAVideo
}

/* Schemas */
export const ContentPropsSchema = z.object({
  technicalName: z.string().optional(),
  title: z.string().optional(),
  contentText: LooseRichTextSchema,
  subtitle: z.string().optional(),
  ctaLink: CTALinkSchema.optional(),
  ctaVideo: CTAVideoSchema.optional(),
})

/* Schemas validation */
type TestContentProps = ExpectTrue<
  Equal<LoosenRichTextFields<ContentProps>, z.infer<typeof ContentPropsSchema>>
>
